// Func = limiting Scope for this file
var lastScrollTop = 0;

//datepicker booking 
var opened = 0; 
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
} 

document.addEventListener("DOMContentLoaded", DOMReady);
(function(){

    let url = document.URL;
    let form_id = "2561"
    if( url.indexOf( "/contact" ) != "-1" ){
        let reason_for_inquiry = document.querySelector( `#form_id-${form_id} [name=reason_for_inquiry]` )
        if( reason_for_inquiry ){
            document.querySelector( `#form_id-${form_id}` ).innerHTML += '<input type="hidden" value="marketing@krcmaine.com" name="emailcc[]">'
           
            document.querySelector( `#form_id-${form_id} [name=reason_for_inquiry]` ).addEventListener( "change", (e) => {

                let hidden = document.createElement( "input" )
                hidden.type = "hidden"
                hidden.value = "dining@krcmaine.com"
                hidden.name = "emailcc[]"

                if( e.target.value == "restaurant" )
                    document.querySelector( `#form_id-${form_id}` ).appendChild( hidden )
                else
                    document.querySelector( `#form_id-${form_id} input[value="dining@krcmaine.com"]` ).remove()

            } )
                
        }
    }

    if(!(window.ActiveXObject) && "ActiveXObject" in window) {

        //is explorer
        function msieversion() {
            let ua = window.navigator.userAgent;
            let msie = ua.indexOf("MSIE ");
            if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
            {
                const image_fit = document.getElementsByClassName('image-fit__wrapper');
                for(let i = 0; i < image_fit.length; i++ ){
                    const this_image = image_fit[i].getElementsByTagName('img')[0];
                    const image_data = this_image.dataset.srcset;
                    const image_src = this_image.getAttribute('src');
                    image_fit[i].classList.add('ie-bg');
                    if(image_data){
                        image_fit[i].style.backgroundImage = 'url("'+image_data+'")';
                    }else{
                        image_fit[i].style.backgroundImage = 'url("'+image_src+'")';
                    }

                }
            }
            else
            {
                console.log('other browser');
            }
            return false;
        }
        msieversion();

    } else {
        /*****************************************************
         OBSERVER TO ADD PARALLAX EFFECT
         /*****************************************************/
        let scrollParallax = []
        let scrolled = 0

        // screen height
        let v_height = window.innerHeight
            || document.documentElement.clientHeight
            || document.body.clientHeight;

        function doParallax(elm) {

            let boundes = elm.dataset.parallax.split(",") // get it from html
            //get distance in positive value
            let distance = Math.abs(boundes[0] - boundes[1])
            if (boundes[0] > boundes[1]) {
                //get distance in negative value (to do the scroll inverse)
                distance = distance * -1
            }
            //Equivalent distance using screen height + element height
            const unit_scroll = distance / (v_height + elm.offsetHeight)
            let temp = 0

            let topElement = 0;
            let element = elm;

            let id_elem = elm.dataset.parallaxid

            do {
                topElement += element.offsetTop || 0;
                element = element.offsetParent;
            } while (element)

            let parallaxFunction = function () {
                //Obtain the distance between top screen and document top 0
                scrolled = document.documentElement.scrollTop || window.pageYOffset
                //Distance of bottom page to top of the element
                let relative_distance = scrolled + v_height - topElement
                //transpoling data to move the parallax element relative to the scroll of all the screen
                temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
                //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
                elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
            }

            scrollParallax[id_elem] = parallaxFunction

            window.addEventListener('scroll', scrollParallax[id_elem])

        }

        let observers_parallax = document.querySelectorAll(".js-parallax-element")

        if (observers_parallax) {
            let options_parallax = {
                root: null, // relative to document viewport
                rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
                threshold: 0 // visible amount of item shown in relation to root
            }

            function handler_parallax(entries, observer) {
                let entry;
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        doParallax(entry.target)
                    } else {
                        let id_elem = entry.target.dataset.parallaxid
                        window.removeEventListener('scroll', scrollParallax[id_elem])
                    }
                })
            }

            let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
            let counter = 1
            observers_parallax.forEach(function (element) {
                observable_parallax.observe(element)
                element.dataset.parallaxid = counter
                counter++
            }) 
        }
        /********************************************************************************
         END OF OBSERVER TO ADD PARALLAX EFFECT
         ***********************************************************************************/
    }

    let formModule = document.querySelectorAll('.form-module-wrapper form');
    let textModule = document.querySelectorAll('.text-modules-wrapper .text-modules');
    if(formModule){
        formModule.forEach(function(form_module) {
            form_module.classList.add('animate-fade', 'top');
        });
    }
    if(textModule){
        textModule.forEach(function(text_module) {
            text_module.classList.add('animate-fade', 'top');
        });
    }

    let Body = document.body;
    let BurgerMenu = document.getElementById('js_btn_menu');
    let NavigationBox = document.getElementById('navigationBox');
    let Header = document.getElementById('header');
    let textJs = document.getElementById('text-js');

    if(BurgerMenu){
        BurgerMenu.addEventListener('click', function(e){
            e.preventDefault();
            if(this.classList.contains("open")){
                this.classList.remove('open');
                NavigationBox.classList.remove('open');
                Body.classList.remove('noScroll');
                textJs.innerHTML = "Menu";
                Header.classList.remove('open');
            } else {
                this.classList.add('open');
                NavigationBox.classList.add('open');
                textJs.innerHTML = "close";
                Body.classList.add('noScroll');
                Header.classList.add('open');
            }
        });
    }

    window.onload = function() {

        if(document.getElementsByClassName('no-hero').length > 0){
            headerLogoSwitch();
        } else {
            scrollW();
            window.addEventListener('scroll', function(){
                scrollW();
            })
        }

        
    };

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }

    //FAQ
    let tabLabel = document.querySelectorAll('.tab-label');
    if(tabLabel){
        tabLabel.forEach(entry => {
            let thisHeightTap = entry.clientHeight + 1;
            let thisHeight = entry.nextElementSibling.clientHeight + thisHeightTap;
            entry.parentElement.style.height = thisHeightTap+'px';
            if(entry.classList.contains('open')){
                entry.parentElement.style.height = thisHeight+'px';
            }
            entry.addEventListener('click', function(event){
                let currentclick = this;
                if(!this.classList.contains('open')){
                    tabLabel.forEach(ent => {
                        if(ent !== currentclick){
                            if(ent.classList.contains('open')){
                                ent.classList.remove('open');
                                ent.parentElement.style.height = thisHeightTap+'px';
                            }
                        }
                    });
                    this.classList.add('open');
                    this.parentElement.style.height = thisHeight+'px';
                } else {
                    this.classList.remove('open');
                    this.parentElement.style.height = thisHeightTap+'px';
                }
            });
        });
    }

    $('[data-fancybox]').fancybox({
        loop : true,
        backFocus: false,
        autoFocus: false,
    });

    let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a#js_btn_book, a.ui-state-default))");
    if(aHref){
        aHref.forEach(function(a_href) {
            a_href.addEventListener('click', function(e){
                e.preventDefault();
                let strAnchor = this.hash.slice(1);
                animateto(strAnchor);
            });
        });
    }

    let aBtn = document.querySelectorAll(".btn:not(.attractions-map__expand), .signup-btn");
    if(aBtn){
        aBtn.forEach(function(a_btn) {
            let htmlString = a_btn.innerText;
            a_btn.innerHTML = '<span>'+htmlString+'</span>';
        });
    }

    

    /*MOBILE MENU NAV
	****************************************************************/

    let Html = document.getElementsByTagName('html')[0];
    let MenuBtn = document.getElementById('menu-btn');
    let CloseMenu = document.querySelectorAll('.close-menu');
    let Navigation = document.querySelectorAll('.navigation');
    let NavUl = document.querySelectorAll('.navigation .inner ul li');
    let NavA = document.querySelectorAll('.navigation .inner ul li a');
    let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

    //Open Navigation
    if(MenuBtn){
        MenuBtn.addEventListener('click', function(e){
            Html.classList.add('hide-overflow');
            Navigation[0].classList.add('open');
            NavUl.forEach(function(inner) {
                if(inner.classList.contains('item-open')){
                    inner.scrollIntoView(false);
                }
            });
        });

        // Sub-Navigation
        // Open active sub-nav on load
        NavActive.forEach(function(inner) {
            inner.closest('.inner').classList.add('open');
            inner.parentNode.parentNode.parentNode.parentNode.classList.add('item-open');
            inner.closest('.sub-sub-menu').classList.add('menu-open');
        });

        //Toggle open/close on tap
        NavA.forEach(function(entry) {
            if(entry.nextElementSibling){
                let clientHeight = entry.nextElementSibling.querySelector('.submenu').clientHeight;
                if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
                    entry.nextElementSibling.classList.add('menu-open');
                    entry.nextElementSibling.style.height = clientHeight+'px';
                }
                entry.addEventListener('click', function(e){
                    e.preventDefault();
                    if(this.nextElementSibling.classList.contains('menu-open')){
                        this.nextElementSibling.classList.remove('menu-open');
                        this.nextElementSibling.style.height = '0px';
                    } else {
                        NavUl.forEach(function(ul) {
                            if(ul.querySelector('.sub-sub-menu')){
                                if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
                                    ul.querySelector('.sub-sub-menu').style.height = '0px';
                                    ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
                                }
                            }
                        });
                        this.nextElementSibling.classList.add('menu-open');
                        this.nextElementSibling.style.height = clientHeight+'px';
                    }
                });
            }
        });
    }

    //Close Navigation
    if(CloseMenu[0]){
        CloseMenu[0].addEventListener('click', function(e){
            Html.classList.remove('hide-overflow');
            Navigation[0].classList.remove('open');
        });
    }

    let notCharge = document.querySelectorAll('.not-charge');
    if (notCharge){
        notCharge.forEach(entry => {
            entry.addEventListener('click', function(event){
                event.preventDefault();
            });
        });
    }

    let screenHeight = document.documentElement.clientHeight;
    let homeTopImg = document.getElementById('home');
    if(homeTopImg){
        homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
            entry.style.height = screenHeight+'px';
        });
        window.addEventListener("resize", function(){
            screenHeight = document.documentElement.clientHeight;
            homeTopImg.querySelectorAll('.top-img figure, .top-img video').forEach(entry => {
                entry.style.height = screenHeight+'px';
            }); 
        });
    }

})();

function animateto(target){ 
    var gotoTarget = offset(document.getElementById(target)).top - 130;
    var from     = window.pageYOffset
    var to       = gotoTarget
    var duration = 1300;
    var start = new Date().getTime()

    //time interval
    var timer = setInterval(function() {
        var time = new Date().getTime() - start

        if(from <= to ){
            var y = easeInOutQuart(time, from, to - from, duration)
        } else {

            var y = easeInOutQuart(time, from, -(from - to), duration)
        }
        window.scrollTo(0, y)
        if (time >= duration) clearInterval(timer)

    }, 1000 / 60);

    window.scrollTo(0, from)

}
//ease movement
function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
    var rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
//ScrollW
function scrollW(){

    //check scroll down or up for header styles
    let st = window.pageYOffset || document.documentElement.scrollTop;
    let header = document.getElementById('header');
    if(st > 80){
        if(!header.classList.contains('down')){
            header.classList.add('down');
            header.classList.remove('up');
            headerLogoSwitch();
        }
    } else {
        if(header.classList.contains('down')){
            header.classList.remove('up');
            header.classList.remove('down');
            headerLogoSwitch();
        }
    }

    let SubMenu = document.getElementById('subMenuAnchor');
    if(SubMenu){
        let subPost = document.getElementById('subMenu');
        let subPosition = '';
        if(document.body.classList.contains('alert_open')){
            subPosition = offset(SubMenu).top - 122;
        } else {
            subPosition = offset(SubMenu).top - 78;
        }
        if(st > subPosition){
            if(!subPost.classList.contains('floating-up')){
                subPost.classList.add('floating-up');
            }
        } else {
            if(subPost.classList.contains('floating-up')) {
                subPost.classList.remove('floating-up');
            }
        }
    }
 
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}


// Dom Ready Funtion
function DOMReady() {

    "use strict";


	// ------- End email signup animation -------

    // Main Nav Dropdown
        let primaryNav = document.getElementById('primary-nav');
        if(primaryNav){
            primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
                primary_nav.addEventListener("mouseover", (event) => {
                    primary_nav.classList.add('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.add('open');
                    }
                });
                primary_nav.addEventListener("mouseout", (event) => {
                    primary_nav.classList.remove('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.remove('open');
                    }
                });
            });
        }
	// ------- End Main Nav Dropdown -------

	// ------- Sliders SWIPER -------
        const swiperClass = ".swiperJs"; 
        const swiperOps = {
            uniqueNavElements: false,
            loop: true,
            speed: 1400,
            effect: 'fade',
            fadeEffect: {
            crossFade: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }, 
            autoplay: {
                delay: 5000, 
                disableOnInteraction: false
            },
            on: {
            autoplayTimeLeft(s, time, progress) {
                progressCircle.style.setProperty("--progress", 1 - progress);
                progressContent.textContent = `${Math.ceil(time / 1000)}s`;
            }
            }
        };
        document.querySelectorAll(swiperClass).forEach((element,i) => {

            let swiperOps = element.dataset.swiper ? JSON.parse(element.dataset.swiper): swiperOps;
            element.setAttribute(`data-swiper-${i}`,"")
            let swiper = new Swiper(`[data-swiper-${i}]`, swiperOps);

            // start count custom
            customcount(`[data-swiper-${i}] ${swiperOps.customcount}`);

            swiper.on('slideChange', () => { 
                // //refresh count cutom
                document.querySelectorAll(`[data-swiper-${i}] .counter`).forEach((element) =>{
                    element.innerHTML = `0${swiper.realIndex + 1}`   ;
                    
                });

                // // Reference Points Accommodations Map
                if(document.getElementsByClassName('accommodationsMap').length > 0){                    
                    let itemPoints = document.querySelectorAll('.item-change');
                    let realIndexItems = swiper.realIndex;
                    let realIndexNumber = realIndexItems + 1;
                    if (itemPoints[realIndexItems].textContent == realIndexNumber) {
                        itemPoints.forEach((element) =>{
                            element.classList.remove('active');                              
                        });
                        itemPoints[realIndexItems].classList.add('active');  
                    }
                }                         
            });

            //add custom count 
            function customcount(element){
                let countcontainerall= document.querySelectorAll(element);
                countcontainerall.forEach((element) =>{
                    let addstring =`<span class="count-line"></span><span class="counter">0${swiper.realIndex + 1} </span>                                                                                                       
                                                    <div class="autoplay-progress">
                                                    <svg viewBox="0 0 48 48">
                                                    <circle cx="24" cy="24" r="20"></circle>
                                                    </svg>
                                                    <span></span>
                                                </div>`;
                    element.innerHTML = addstring;

                });
            }

            // slide Go To in Accommodation Map
            if(document.getElementsByClassName('accommodationsMap').length > 0){
                document
                .querySelector('.slide-1')
                .addEventListener('click', function (e) {
                    e.preventDefault();            
                    swiper.slideTo(0, 1000);
                });
                document
                .querySelector('.slide-2')
                .addEventListener('click', function (e) {
                    e.preventDefault();    
                    swiper.slideTo(1, 1000);
                });
                document
                .querySelector('.slide-3')
                .addEventListener('click', function (e) {
                    e.preventDefault();    
                    swiper.slideTo(2, 1000);
                });
            }
        });


    // ------- end Sliders SWIPER ----------

	// ------- Hovered Items Navs -------
	let itemMenu = document.querySelectorAll('.privary-navigation__item a');
	let itemMenuSecond = document.querySelectorAll('.secondary-navigation__item a');
	let itemMenuThrid = document.querySelectorAll('.tertiary-navigation__item a');
	let itemsAddress = document.querySelectorAll('.address a');
	let itemsSocial = document.querySelectorAll('.social-media a');

	function addClassHovered(arrayItems){
		arrayItems.forEach(function (i) {
			(i).addEventListener("mouseover", function( event ) { 
				i.parentNode.parentElement.classList.add('s-hovered')
			}, false);
			(i).addEventListener("mouseout", function( event ) {   
				i.parentNode.parentElement.classList.remove('s-hovered')
			  }, false);
		});
	};

	addClassHovered(itemMenu);
	addClassHovered(itemMenuSecond);  
	addClassHovered(itemMenuThrid);  
	addClassHovered(itemsAddress); 
	addClassHovered(itemsSocial); 
	// ------- end spaces page ----------
	// ------- spaces page ----------
    if(document.getElementsByClassName('check-availability').length > 0){
        document.getElementsByClassName('check-availability')[0].addEventListener('click', function(){
            document.getElementsByClassName('booking-content')[0].classList.add('open');
        });

        document.getElementsByClassName('booking-close')[0].addEventListener('click', function(){
            document.getElementsByClassName('booking-content')[0].classList.remove('open');
        });
    }
	// ------- end spaces page ----------

	// ------- Init rooms  ----------
    if( document.getElementById('roomsList') ){
        const listContainer = document.getElementById('roomsList');
        
        (function(){
            loadRoomsbyTag('all');
            if(document.getElementsByClassName('js-room-tag').length > 0){
                let allLiFilter = document.getElementsByClassName('js-room-tag');
                for(let i =0; i < allLiFilter.length; i++){
                    allLiFilter[i].addEventListener('click', function(){
                        let currentTarget = this.getAttribute('data-target');
                        for(let j =0; j < allLiFilter.length; j++){
                            if(currentTarget == allLiFilter[j].getAttribute('data-target')){
                                allLiFilter[j].classList.add('active')
                            } else {
                                allLiFilter[j].classList.remove('active')
                            }
                        }
                        loadRoomsbyTag(currentTarget);
                    });
                }
            }
            if(document.getElementById('roomsSelect')){
                document.getElementById('roomsSelect').addEventListener('change', function(){
                    let currentTarget = this.value;
                    loadRoomsbyTag(currentTarget);
                })
            }
            
        }())
        function loadRoomsbyTag(room){
            listContainer.classList.add('loading');
            listContainer.classList.remove('ready');
            fetch(`${site_url}ajax/functions.php?operation=getRoomsByTag&tag=`+room,{method: "GET"})
                .then((resp) => resp.json()) // Transform the data into json
                .then((data) => {
                    setTimeout(function(){
                        listContainer.innerHTML = data.html; //set data response via fetch in the container
                        
                    },500);
                    
                }).then((data) => {
                    setTimeout(function(){
                        listContainer.classList.remove('loading');
                        listContainer.classList.add('ready');

                        const swiperClass = ".swiperJs"; 
                        const swiperOps = {
                            uniqueNavElements: false,
                            loop: true,
                            speed: 1400,
                            effect: 'fade',
                            fadeEffect: {
                            crossFade: true,
                            },
                            navigation: {
                            nextEl: '.swiper-next',
                            prevEl: '.swiper-prev'
                            }, 
                            autoplay: {
                                delay: 5000, 
                                disableOnInteraction: false
                            },
                            on: {
                            autoplayTimeLeft(s, time, progress) {
                                progressCircle.style.setProperty("--progress", 1 - progress);
                                progressContent.textContent = `${Math.ceil(time / 1000)}s`;
                            }
                            }
                        };
                        document.querySelectorAll(swiperClass).forEach((element,i) => {
                
                            let swiperOps = element.dataset.swiper ? JSON.parse(element.dataset.swiper): swiperOps;
                            element.setAttribute(`data-swiper-${i}`,"")
                            let swiper = new Swiper(`[data-swiper-${i}]`, swiperOps);
                
                            // start count custom
                            // customcount(`[data-swiper-${i}] ${swiperOps.customcount}`);
                
                            swiper.on('slideChange', () => { 
                                // //refresh count cutom
                                document.querySelectorAll(`[data-swiper-${i}] .counter`).forEach((element) =>{
                                    element.innerHTML = `0${swiper.realIndex + 1}`   ;
                              
                                });
                            
                            });
                
                            //add custom count 
                            // function customcount(element){
                            //     let countcontainerall= document.querySelectorAll(element);
                            //     countcontainerall.forEach((element) =>{
                            //         let addstring =`<span class="count-line"></span><span class="counter">0${swiper.realIndex + 1} </span>                                                                                                       
                            //                                         <div class="autoplay-progress">
                            //                                         <svg viewBox="0 0 48 48">
                            //                                         <circle cx="24" cy="24" r="20"></circle>
                            //                                         </svg>
                            //                                         <span></span>
                            //                                     </div>`;
                            //         element.innerHTML = addstring;
                            //     });
                            // }
                        });
                
                
                    if(document.getElementsByClassName('lightbox').length > 0){
                        let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
                        let allLightboxesLength = allLightboxes.length;

                        for(let j = 0; j < allLightboxesLength; j++ ){
                            allLightboxes[j].addEventListener('click', function(e){
                                e.preventDefault();
                                let currentTarget = this.getAttribute('href').split('#')[1];
                                if(!document.getElementById(currentTarget).classList.contains('open')){
                                    document.getElementById(currentTarget).classList.add('open')
                                } else {
                                    document.getElementById(currentTarget).classList.remove('open')
                                }
                            });
                        }

                        let allLightcloses = document.getElementsByClassName('js-lightboxclose');
                        let allLightclosesLength = allLightcloses.length;

                        for(let j = 0; j < allLightclosesLength; j++ ){
                            allLightcloses[j].addEventListener('click', function(e){
                                e.preventDefault();
                                let currentTarget = this.parentElement.parentElement.id;
                                if(!document.getElementById(currentTarget).classList.contains('open')){
                                    document.getElementById(currentTarget).classList.add('open')
                                } else {
                                    document.getElementById(currentTarget).classList.remove('open')
                                }

                                if(document.getElementsByClassName('lightbox-video').length > 0){
                                    let allVideos = document.getElementsByClassName('lightbox-video');
                                    for(let h = 0; h < allVideos.length; h++){
                                        allVideos[h].pause();
                                    }
                                }

                            });
                        }
                    }
                        
                    },500);

            });
        }
    }
	// ------- End Init rooms  ----------

	// ------- TODO: Init Booking  ----------

    $('.plus').click(function(){
    	const this_input_val = parseInt($(this).siblings('input').val());
    	$(this).siblings('input').val(this_input_val+1);
    });
    $('.minus').click(function(){
    	const this_input_val = parseInt($(this).siblings('input').val());
    	if(this_input_val > 0){
    		$(this).siblings('input').val(this_input_val-1);
    	}
    })
    function fillStartDateDropdowns(date_m_d_yy) {

        var strFilled;
        strFilled = date_m_d_yy.split("/");

        $(".startmonth").val((strFilled[0]-1)+strFilled[2]);  //put values
        $(".startday").val(strFilled[1]);
    }
    function fillEndDateDropdowns(date_m_d_yy) {

        var strFilled;
        strFilled = date_m_d_yy.split("/");

        $(".endmonth").val((strFilled[0]-1)+strFilled[2]);   //put values
        $(".endday").val(strFilled[1]);
    }

    //Check in and check out datepicker for booking engine
    $( "#CheckIn" ).datepicker({
        //showOn: "both",
        //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
        //buttonImageOnly: true,
        monthNamesShort: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        dayNamesMin: [ "SU", "MO", "TU", "WE", "TH", "FR", "SA" ],
        changeMonth: true,
        numberOfMonths: 1,
        minDate: "+0D",
        onSelect: function( selectedDate ) {
            let getDate = $(this).datepicker('getDate');
            let newDate = new Date(getDate.getTime());
            newDate.setDate(newDate.getDate() + 1);
            $( "#CheckOut" ).datepicker( "setDate", newDate );
            $( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );

            fillStartDateDropdowns($(this).val());
            fillEndDateDropdowns($('#CheckOut').val());
        }
    });

    $("#CheckOut").datepicker({
      //showOn: "both",
      //buttonImage: SITE_FILES+"images/img-calendar-gray.png",
      //buttonImageOnly: true,
      monthNamesShort: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      dayNamesMin: [ "SU", "MO", "TU", "WE", "TH", "FR", "SA" ],
      changeMonth: true,
      minDate: "+1D",
      numberOfMonths: 1,
      onSelect: function (selectedDate) {
        //$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
        fillEndDateDropdowns($(this).val());
      },
    });

    /* Datepicker to date in June */
    let InDate = new Date('06-01-2022');
    InDate.setFullYear(InDate.getFullYear())
    let OutDate = new Date('06-30-2022');
    OutDate.setFullYear(OutDate.getFullYear())

    /* Datepicker in Landing page */
    $( "#CheckInLanding" ).datepicker({
        monthNamesShort: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        dayNamesMin: [ "SU", "MO", "TU", "WE", "TH", "FR", "SA" ],
        changeMonth: false,
        dateFormat: 'mm/dd/yy',
        numberOfMonths: 1,
        minDate: InDate,
        maxDate: OutDate,
        onSelect: function( selectedDate ) {
            let getDate = $(this).datepicker('getDate');
            let newDate = new Date(getDate.getTime());
            newDate.setDate(newDate.getDate() + 1);
            $( "#CheckOut" ).datepicker( "setDate", newDate );
            $( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );

            fillStartDateDropdownsLanding($(this).val());
            fillEndDateDropdownsLanding($('#CheckOut').val());
        }
    });

    $("#CheckOutLanding").datepicker({
        monthNamesShort: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        dayNamesMin: [ "SU", "MO", "TU", "WE", "TH", "FR", "SA" ],
        changeMonth: false,
        numberOfMonths: 1,
        minDate: InDate,
        maxDate: OutDate,
        onSelect: function (selectedDate) {
            fillEndDateDropdownsLanding($(this).val());
        }, 
    });
	// ------- END Booking  ---------- 

	// ------- TODO: Refactor vanila Menu  ----------
        let currentMenuItem = $(".quad-menus__tabs-nav li.active").index();    
        $(".slideJS:eq(" + currentMenuItem + ")").addClass("active");
        document.querySelectorAll(".js-menu-tab").forEach((btn) => {
        btn.addEventListener("click", (_) => {
            $(".js-menu-tab.active").removeClass("active");
            $(btn).addClass("active");
            $(".quad-menus__menu-content.active").removeClass("active");
            var tabNumber = $(btn).attr("data-menuid");
            var tabToOpen =
            ".quad-menus__menu-content[data-menuid='" + tabNumber + "']";
            $(tabToOpen).addClass("active");
            $(".quad-menus__tabs-image.active").removeClass("active");
            var imgToOpen =
            ".quad-menus__tabs-image[data-menuid='" + tabNumber + "']";
            $(imgToOpen).addClass("active");
            $(".name-bg.active").removeClass("active");
            var wordToOpen = ".name-bg[data-menuid='" + tabNumber + "']";
            $(wordToOpen).addClass("active");
            let currentMenuItem = $(".quad-menus__tabs-nav li.active").index();
            $(".slideJS.active").removeClass('active');
            $(".slideJS:eq(" + currentMenuItem + ")").addClass("active");
        });
        });
	// ------- END Menu  ----------

	// ------- tablet / mobile menu cta -------
        if(document.getElementById('menu-sm-cta-js')){
            let menuMobile = document.getElementById('box-primary-nav');
            document.getElementById('menu-sm-cta-js').addEventListener('click', function(e){
                e.preventDefault();
                if(menuMobile.classList.contains('closed')){
                    document.getElementById('box-primary-nav').classList.remove('closed');
                    this.classList.add('closed');
                    document.getElementById('menutext-js').innerHTML = 'Close';
                    document.getElementById('header').classList.add('open-menu');
                    document.querySelector("body").classList.add('noScroll')
                    if(lastScrollTop < 80){
                        document.getElementById('header').classList.remove('open-menu');
                    }
                } else {
                    document.getElementById('box-primary-nav').classList.add('closed');
                    this.classList.remove('closed');
                    document.getElementById('menutext-js').innerHTML = 'Menu';
                    document.querySelector("body").classList.remove('noScroll');
                }
            });
            document.getElementById("close-menu").addEventListener("click", function () { 
                document.getElementById('box-primary-nav').classList.add('closed');
                this.classList.remove('open');
                document.getElementById('menutext-js').innerHTML = 'Menu';
                document.querySelector("body").classList.remove('noScroll');
            });
        }
	// ------- End tablet / mobile menu cta -------

	// ------- Dropdown for mobile -------
        document.querySelectorAll('.bl-primary-nav #privary-navigation a').forEach(link => {
            link.addEventListener('click', e => {
                if (link.nextSibling.nextSibling != null) {
                    document.querySelectorAll('.bl-primary-nav #privary-navigation a').forEach(item => {
                        if (link.parentNode !== item) item.classList.remove('js-submenu-show');
                    });
                    //remove this comment if you want show subnav for mobile
                    e.preventDefault();
                    link.parentNode.classList.toggle('js-submenu-show');
                }
            });
        }); 

        //add class for icon dropdown 
        document.querySelectorAll('.bl-primary-nav #privary-navigation .submenu').forEach(link => {
            let menu = link.parentNode;
            menu.classList.add('ico-dropdown');
        });
	// ------- End dropdown for mobile  -------

	// ------- Hover active logo of the building -------
    if(document.querySelector('.bg-map') || document.querySelector('.floorplans')){
        let building = document.querySelectorAll('[data-point]');
        building.forEach(function(element){
            element.addEventListener("mouseover", (e) => {
                let data = e.target.dataset.point;
                building.forEach(function(item){
                    if (item.dataset.point == data) {
                        item.classList.add('active');
                    }
                })
            });

            element.addEventListener("mouseout", (e) => {
                building.forEach(function(item){
                    item.classList.remove('active');
                })
            }); 
        })
    }

	// ------- END Hover active logo of the building -------


	// -------  Main Nav Dropdowng Gallery -------
    if (document.querySelectorAll("#privary-navigation-desktop li .overview-accommodations")) {  
        let itemsNav = document.querySelectorAll("#privary-navigation-desktop li .overview-accommodations");
        itemsNav.forEach((item) => {   
            item.parentElement.classList.add("item-accommodations");
            item.nextElementSibling.classList.add('subMenu-accommodations');
        });

        const navigation = document.querySelector(".primary-nav-1");
        const first_gallery = document.querySelector("#accommodations-menu");
        if(first_gallery){
            navigation.append(first_gallery);
        }
        
      } 
	// ------- END Main Nav Dropdowng -------

    // ------- Room Sleeps Filter -------
    
    if (document.querySelectorAll('[data-sleeps]').length > 0) {
        let roomSleeps = [];
        let allRooms = document.querySelectorAll('[data-sleeps]');

        allRooms.forEach(room => {
            if (!roomSleeps.includes(room.dataset.sleeps) && room.dataset.sleeps)
                roomSleeps.push(room.dataset.sleeps);
        });

        roomSleeps = roomSleeps.map(option => `<option value="${option}">SLEEPS ${option}</option>`).join('');

        document.getElementById('room-sleeps').innerHTML += roomSleeps;

        document.getElementById('room-sleeps').addEventListener('change', function() {
            allRooms.forEach(room => {
                room.dataset.sleeps == this.value || this.value == 'all' ? room.classList.remove('hidden') : room.classList.add('hidden');
            })
        })
    }
    // ------- END Room Sleeps Filter -------
};

function headerLogoSwitch() {
    if(document.getElementById('headerLogo')){
        let currentSrc = document.getElementById('headerLogo').getAttribute('src');
        let altSrc = document.getElementById('headerLogo').getAttribute('alt-logo');

        document.getElementById('headerLogo').setAttribute('src',altSrc);
        document.getElementById('headerLogo').setAttribute('alt-logo',currentSrc);
    }
}